import type { Options } from './types'
import { initOptions } from './option'
import { initPv } from './pv'

function init(options: Options) {
  initOptions(options)
  initPv()
}

export * from './types'

export {
  init
}
